import * as tslib_1 from "tslib";
import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import Application from "@cloudpivot/application/pc";
import themeSetting from './../../setting/theme-seting.vue';
import { Dropdown, Modal, Input, Row, Col, Menu, Popover, Icon, Tooltip, Drawer } from "@h3/antd-vue";
import OAuthApi from "@/apis/oauth";
import env from "@/config/env";
import site from "@/config/site";
import { listApi, workbenchApi } from "@cloudpivot/api";
import getDownloadUrlNew from '@cloudpivot/common/src/utils/getDownloadUrlNew';
import { namespace } from "vuex-class";
import ModifyPwd from "../../setting/modify-pwd.vue";
import MySetting from "../../setting/my-setting.vue";
import noticeTips from "./noticeTips.vue";
import common from "@cloudpivot/common";
const WorkflowCenterModule = namespace("WorkflowCenter/WorkflowCenter");
const SystemModule = namespace("System/System");
let CommonHeader = class CommonHeader extends Vue {
    constructor() {
        super(...arguments);
        // @ts-ignore 是否开启了应用门户
        this.openApplicationPortal = window.config.openApplicationPortal || false;
        this.searchVisible = false;
        this.moveIn = false;
        this.openSettintTheme = false;
        this.noticesCount = 0;
        this.noticesTimer = null;
        this.defaultSelectedKeys = "curso";
        this.isShow = false; //个人设置弹窗
        this.isShow2 = false; //密码过于简单时弹窗修改密码
        // 只有自维护的用户并且不是admin这个账户才能有修改密码入口 #39826
        this.isShowUpdatePwdBtn = true;
        this.isMove = false; //应用动画效果
        // 用户信息
        this.userInfo = {};
        this.showModal = false;
        this.showAppList = false;
        this.params = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.oldPwdErrTips = "";
        this.newPwdErrTips = "";
        this.surePwdErr = false;
        this.visible = false;
        this.appVisible = false;
        this.appGroupList = [];
        this.appList = [];
        // appName: any = {
        //   name: '',
        //   name_i18n: '',
        // };
        this.isLoaded = false; //是否已加载过
        this.isInit = false;
        this.isAppAdmin = false;
        this.isSysAdmin = false;
    }
    apiHost() {
        return window.config.apiHost;
    }
    token() {
        return window.localStorage.getItem("token");
    }
    toggleSearchVisible() {
        this.searchVisible = !this.searchVisible;
    }
    onSearchVisibleChange(val) {
        this.$nextTick(() => {
            this.moveIn = val;
        });
    }
    get appName() {
        return this.$store.state.WorkflowCenter.WorkflowCenter.appName;
    }
    toChangeTheme() {
        this.openSettintTheme = true;
    }
    // 消息通知显示
    noticeTipsVisibleChange(visible) {
        if (visible) {
            // @ts-ignore
            this.$refs.noticeTips && this.$refs.noticeTips.paltformSearch();
        }
    }
    // 获取消息通知数量
    paltformSearch() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield workbenchApi.paltformSearch({
                searchword: '',
                size: 1,
                page: 0,
                tab: 'MESSAGE',
                readState: 'UNREADED'
            });
            if (res.errcode === 0) {
                this.noticesCount = res.data.MESSAGE.totalElements;
                this.autoGetNoticesCount();
            }
        });
    }
    autoGetNoticesCount() {
        this.noticesTimer = setTimeout(() => {
            this.paltformSearch();
        }, 60000);
    }
    closeSearchResulte() {
        this.searchVisible = false;
    }
    get isChinese() {
        return !(this.$i18n.locale && this.$i18n.locale === "en");
    }
    get isAppList() {
        return this.$store.state.WorkflowCenter.WorkflowCenter.isAppList;
    }
    get logo() {
        return site.logo;
    }
    get logoSrc() {
        const refId = this.$store.state.themsConfig.portalLogo;
        return refId ? this.getDownloadUrlByRefId(refId) : '';
    }
    getDownloadUrlByRefId(refId) {
        return getDownloadUrlNew.getImageUrl(refId, 'logo');
    }
    get isShowToggle() {
        return this.$store.state.config.multiLanguageSwitch;
    }
    get isCloudPivot() {
        // 是否已打开内部维护组织开关
        return this.$store.state.config.cloudPivot;
    }
    get routeName() {
        return this.$route.name;
    }
    getPopupContainer(trigger) {
        return trigger.parentElement;
    }
    //应用的弹窗
    isChange2(e) {
        if (!e) {
            this.isMove = false;
            return;
        }
        ;
        // 获取当前选中的菜单名称
        if (!this.userInfo.username) {
            this.getUserInfo();
        }
        //获取应用列表
        if (this.appList.length < 1) {
            this.getList(!this.isInit);
        }
        //获取应用组列表
        if (this.appGroupList.length < 1) {
            this.getAppGroupList();
        }
        this.isMove = true;
    }
    isChange(e) {
        if (!e) {
            this.appClose();
        }
        this.isMove = e;
    }
    /**
     * 初始化应用信息
     */
    initApp() {
        let data = location.pathname.split('/');
        data = data.filter(item => item);
        const code = data[1];
        const item = this.appList.find(item => item.code === code);
        if (!item)
            return;
        this.setAppPath(location.href);
        this.goToDetail(item);
        this.isInit = true;
    }
    /**
     * 应用详情
     */
    goToDetail(item) {
        if (!item)
            return;
        this.appVisible = false;
        this.triggerChangeTabs(true);
        const appName = {
            name: item.appName || item.name,
            name_i18n: ((item.appName_i18n && item.appName_i18n.en) || (item.appName_i18n && JSON.parse(item.appName_i18n) && JSON.parse(item.appName_i18n).en) || item.appName) || ((JSON.parse(item.name_i18n) && JSON.parse(item.name_i18n).en) || item.name),
        };
        this.setAppName(appName);
        this.setAppCode(item.appCode || item.code);
        this.setModalCode(item.appCode ? item.code : '');
        this.setAppChange(true);
        if (this.$route.path.indexOf('/application-list/') === -1) {
            this.$router.push(`/application/${item.appCode || item.code}`);
        }
        this.isMove = false;
    }
    /**
     * 应用列表关闭
     */
    appClose() {
        // this.defaultSelectedKeys = "curso";
        this.appVisible = false;
        this.isMove = false;
    }
    onRouteNameChange(val) {
        if (val.fullPath && val.fullPath.includes('/application') && !this.isLoaded) { //首次加载
            this.isChange2(true);
            this.isMove = false;
        }
    }
    created() {
        if (this.$route.name === 'messageNotification') {
            this.defaultSelectedKeys = 'messageNotification';
        }
        else if (this.$route.name === 'workbench') {
            this.defaultSelectedKeys = 'workbench';
        }
        this.paltformSearch();
        this.autoGetNoticesCount();
        //获取应用列表
        this.getList();
        //获取应用组列表
        this.getAppGroupList();
        //获取用户信息
        this.getUserInfo();
    }
    mounted() {
        common.utils.Bus.$on('goToModalList', (item) => {
            this.goToDetail(item);
        });
        const singlePwd = localStorage.getItem("singlePwd");
        if (singlePwd && singlePwd === "true") {
            this.isShow2 = true;
        }
        common.utils.Bus.$on('reloadMenu', (item) => {
            this.initApp();
        });
    }
    beforeDestroy() {
        common.utils.Bus.$off('goToModalList');
        common.utils.Bus.$off('reloadMenu');
    }
    closePop() {
        this.isShow2 = false;
        localStorage.removeItem("singlePwd");
    }
    onChange() {
        //获取应用列表
        this.getList();
        //获取应用组列表
        this.getAppGroupList();
    }
    getList(init = false) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.list({ isMobile: false, isPortal: true });
            if (res.errcode === 0) {
                this.appList = res.data;
                if (init) {
                    this.initApp();
                }
            }
        });
    }
    getAppGroupList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield listApi.listByGroup({ isMobile: false, isPortal: true });
            if (res.errcode === 0) {
                this.appGroupList = res.data;
            }
        });
    }
    triggerChangeTabs(flag, type) {
        this.showAppList = false;
        this.setIsAppList(flag);
        if (!flag) {
            switch (type) {
                case 'workbench':
                    this.defaultSelectedKeys = 'workbench';
                    if (!this.openApplicationPortal) {
                        this.$router.push("/workbench-center/workbench");
                    }
                    else {
                        this.$router.push("/application-portal/portal");
                    }
                    break;
                case 'curso':
                    this.defaultSelectedKeys = 'curso';
                    this.$router.push("/workflow-center/my-unfinished-workitem");
                    break;
            }
            // this.$router.push("/workflow-center/my-unfinished-workitem");
        }
    }
    triggerClick(cur, tab) {
        this.showAppList = false;
        if (['workbench', 'curso', 'applicationPortal'].includes(cur)) {
            this.$refs.child && this.$refs.child.close();
        }
        this.setIsAppList(false);
        this.defaultSelectedKeys = cur;
        if (cur === 'workbench') {
            this.$router.push({
                path: "/workbench-center"
            });
        }
        if (cur === 'applicationPortal') {
            this.$router.push({
                path: "/application-portal"
            });
        }
        if (cur === 'curso') {
            this.$router.push("/workflow-center/my-unfinished-workitem");
        }
    }
    mySetting() {
        this.visible = false;
        this.isShow = true;
    }
    // 跳转到个人中心
    toUserInfo() {
        // window.location.href = '/user/info';
        this.$router.push("/user").catch((err) => {
            err;
        });
    }
    // 跳转后台管理
    toAdmin() {
        const token = localStorage.getItem("token");
        if (this.isDingTalk && token) {
            window.open(`${env.portalHost}/admin/?admin_token=${token}`, "_blank");
        }
        else {
            window.open(`${env.portalHost}/admin/`, "_blank");
        }
    }
    // 退出登录confirm
    logoutConfirm() {
        const vm = this;
        vm.$confirm({
            title: this.$t("languages.common.tip.sureToLogOut").toString(),
            okText: this.$t("languages.common.tip.confirm").toString(),
            cancelText: this.$t("languages.common.tip.cancel").toString(),
            onOk() {
                vm.logout();
            },
        });
    }
    // 退出登录
    logout() {
        const logoutIP = env.oauthHost;
        const redirectIP = env.redirectHost;
        const token = localStorage.getItem("token") || "";
        this.setIsAppList(false);
        // window.location.href = `${logoutIP}/logout?redirect_uri=${redirectIP}/login&T=${token}`;
        OAuthApi.logout({
            redirect_uri: `${redirectIP}/login`,
            T: token,
        }).then((res) => {
            localStorage.removeItem("token");
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("expireTime");
            sessionStorage.removeItem("user");
            this.$router.replace({ name: "login" });
        });
    }
    // 跳转到首页
    goHome() {
        const appCode = window.Environment ? window.Environment.appCode : null;
        if (appCode) {
            this.$router
                .push({
                name: "singleApp",
                params: {
                    appCode,
                },
            })
                .catch((err) => {
                err;
            });
        }
        else {
            this.$router.push({ name: "myUnfinishedWorkItem" }).catch((err) => {
                err;
            });
            // 如果回到首页, 重新调整顶部导航栏下的 slider
            this.$refs.applications.initSlider();
        }
    }
    openBlank() {
        var href = location.href;
        var iframeAction = href.match(/%26iframeAction%3Ddetail/g);
        if (Array.isArray(iframeAction) && iframeAction.length > 1) {
            for (let i = 0; i < iframeAction.length - 1; i++) {
                href = href.replace("%26iframeAction%3Ddetail", "");
            }
        }
        const url = `${href}${href.indexOf("?") > -1 ? "&" : "?"}T=${localStorage.getItem("token")}`;
        window.open(url, "_blank");
    }
    // 获取当前用户信息
    getUserInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const res = yield OAuthApi.getUserInfo();
            if (res.errcode === 0) {
                const info = res.data;
                this.userInfo = info;
                this.setUserId(info);
                this.isShowUpdatePwdBtn =
                    (res.data.relatedSyncType === "PUSH" ||
                        this.$store.state.config.loginType === 0 ||
                        this.$store.state.config.loginType === 2) &&
                        res.data.username !== "admin"; // admin这个账号 hide || 或者开启了账号密码登陆的时候
                this.userInfo.isShowUpdatePwdBtn = this.isShowUpdatePwdBtn;
                sessionStorage.setItem("user", JSON.stringify(info));
                // if(localStorage.getItem('userId') && localStorage.getItem('userId') !== JSON.parse(sessionStorage.getItem('user') || '').id) {
                //   localStorage.removeItem('daily');
                //   localStorage.removeItem('temp')
                // }
                if (localStorage.getItem("temp")) {
                    let tempArr = JSON.parse(localStorage.getItem("temp") || "[]");
                    if (tempArr > 2) {
                        tempArr.shift();
                    }
                    localStorage.setItem("temp", JSON.stringify(tempArr));
                }
                else if (localStorage.getItem("daily")) {
                    let dailyArr = JSON.parse(localStorage.getItem("daily") || "[]");
                    if (dailyArr > 2) {
                        dailyArr.shift();
                    }
                    localStorage.setItem("daily", JSON.stringify(dailyArr));
                }
                localStorage.setItem("userId", JSON.parse(sessionStorage.getItem("user") || "").id); //用户ID
                // 判断当前用户角色
                const isAppAdmin = info.permissions.includes("APP_MNG");
                this.isAppAdmin = isAppAdmin;
                const isSysAdmin = info.permissions.includes("SYS_MNG");
                this.isSysAdmin = isSysAdmin;
                const isRootAdmin = info.permissions.includes("ADMIN");
                const isAdmin = isAppAdmin || isSysAdmin || isRootAdmin;
                this.setIsAdmin(isAdmin);
                this.setRootAdmin(isRootAdmin);
                this.setAdmin(isSysAdmin || isRootAdmin);
                this.setUserInfo(info);
                // 设置是否特权人
                const isWORKFLOW_ADMIN = info.permissions.includes("WORKFLOW_ADMIN");
                this.setIsPrivilegedPerson(isWORKFLOW_ADMIN);
                // 禁止无权限访问流程查询页面
                if (!isSysAdmin &&
                    !isRootAdmin &&
                    this.$route.name &&
                    ["queryInstance", "queryParticipantWorkItem"].includes(this.$route.name)) {
                    this.$router.replace({ name: "myUnfinishedWorkItem" });
                }
                // 禁止超管访问流程委托页面
                if (isRootAdmin &&
                    this.$route.name &&
                    ["delegationWorkflow"].includes(this.$route.name)) {
                    this.$router.replace({ name: "myUnfinishedWorkItem" });
                }
            }
        });
    }
    getDownloadUrlNew(refId) {
        return getDownloadUrlNew.getImageUrl(refId);
    }
    /**
     * 切换多语言
     */
    toggleLanguage() {
        if (!(this.$i18n.locale && this.$i18n.locale === "en")) {
            this.$i18n.locale = "en";
        }
        else {
            this.$i18n.locale = "zh";
        }
        this.$forceUpdate();
        localStorage.setItem("locale", this.$i18n.locale);
    }
    /*
     * 修改密码
     */
    changePwd() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.resetErrTips();
            if (!this.params.oldPwd) {
                this.oldPwdErrTips = this.$t("languages.common.oldPwdRequied").toString();
                return;
            }
            if (!this.params.newPwd) {
                this.newPwdErrTips = this.$t("languages.common.newPwdRequied").toString();
                return;
            }
            if (this.params.newPwd !== this.params.surePwd) {
                this.surePwdErr = true;
                this.newPwdErrTips = this.$t("languages.common.newPwdNotSame").toString();
                return;
            }
            const params = {
                username: this.userInfo.username,
                corpId: this.userInfo.corpId,
                oldPassword: this.params.oldPwd,
                newPassword: this.params.newPwd,
            };
            const res = yield OAuthApi.changePassword(params);
            if (res.errcode) {
                this.$message.error(res.errmsg);
                return;
            }
            this.$message.success(`${this.$t("languages.common.changePwdSuccess")}`);
            setTimeout(() => { this.logout(); }, 3000);
        });
    }
    /*
     * 重置密码错误提示
     */
    resetErrTips() {
        this.oldPwdErrTips = "";
        this.newPwdErrTips = "";
        this.surePwdErr = false;
    }
    cancel() {
        this.showModal = false;
        this.params = {
            oldPwd: "",
            newPwd: "",
            surePwd: "",
        };
        this.resetErrTips();
    }
    get outwardType() {
        return this.$store.state.outwardType;
    }
};
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAsideTitle")
], CommonHeader.prototype, "setAsideTitle", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation('setApplicationPageTitle')
], CommonHeader.prototype, "setApplicationPageTitle", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setUserId")
], CommonHeader.prototype, "setUserId", void 0);
tslib_1.__decorate([
    SystemModule.State("isAdmin")
], CommonHeader.prototype, "isAdmin", void 0);
tslib_1.__decorate([
    SystemModule.State("admin")
], CommonHeader.prototype, "admin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setIsAdmin")
], CommonHeader.prototype, "setIsAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setAdmin")
], CommonHeader.prototype, "setAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setIsPrivilegedPerson")
], CommonHeader.prototype, "setIsPrivilegedPerson", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setRootAdmin")
], CommonHeader.prototype, "setRootAdmin", void 0);
tslib_1.__decorate([
    SystemModule.Mutation("setUserInfo")
], CommonHeader.prototype, "setUserInfo", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setIsAppList")
], CommonHeader.prototype, "setIsAppList", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppNameList")
], CommonHeader.prototype, "setAppNameList", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppName")
], CommonHeader.prototype, "setAppName", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppCode")
], CommonHeader.prototype, "setAppCode", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setModalCode")
], CommonHeader.prototype, "setModalCode", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppChange")
], CommonHeader.prototype, "setAppChange", void 0);
tslib_1.__decorate([
    WorkflowCenterModule.Mutation("setAppPath")
], CommonHeader.prototype, "setAppPath", void 0);
tslib_1.__decorate([
    Provide()
], CommonHeader.prototype, "apiHost", null);
tslib_1.__decorate([
    Provide()
], CommonHeader.prototype, "token", null);
tslib_1.__decorate([
    Watch('searchVisible')
], CommonHeader.prototype, "onSearchVisibleChange", null);
tslib_1.__decorate([
    Watch('$route', {
        immediate: true
    })
], CommonHeader.prototype, "onRouteNameChange", null);
CommonHeader = tslib_1.__decorate([
    Component({
        name: "common-header",
        components: {
            ADropdown: Dropdown,
            AModal: Modal,
            AIcon: Icon,
            AInput: Input,
            ARow: Row,
            ACol: Col,
            ApplicationHeader: Application.ApplicationHeader,
            AppList: Application.AppList,
            SearchResulte: Application.SearchResulte,
            AMenu: Menu,
            AMenuItem: Menu.Item,
            APopover: Popover,
            MySetting,
            AInputSearch: Input.Search,
            noticeTips,
            ATooltip: Tooltip,
            ModifyPwd,
            ADrawer: Drawer,
            themeSetting
        },
    })
], CommonHeader);
export default CommonHeader;
